import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

const DOC = gql`
  mutation RevokeApiKey($tenantId: ID!, $zoneId: ID!, $id: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        revokeApiKey(id: $id)
      }
    }
  }
`

export const execute = graphql.createExecutor<
  graphql.schema.RevokeApiKeyMutation,
  void,
  graphql.schema.RevokeApiKeyMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
